module.exports = "/_next/static/images/goireland-77b8f673b58eec615cd58ad0a60889e9.png";